import CartContent from './CartContent'
export default CartContent
